import VideoSectionImplementation from '../implementation/sections/VideoSection';
import { ComponentProps } from '@components/strapi/DynamicZoneComponent';
import {
  StrapiVideoSectionDTO,
  VideoSectionDTO,
} from '@lib/strapi/dtos/components/sections/videoSection.dto';

const VideoSection = (props: ComponentProps<VideoSectionDTO>) => {
  return <VideoSectionImplementation {...props}></VideoSectionImplementation>;
};

export default VideoSection;
